
const LoggerDebug = 4;
const LoggerInfo = 3;
const LoggerWarn = 2;
const LoggerError = 1;

const Logger = {
  level: LoggerDebug,
  
  log(message, ...params) {
    if(this.level >= LoggerDebug){
      console.log(message, ...params)
    }
  },
  
  info (message, ...params) {
    if(this.level >= LoggerInfo){
      console.info(message, ...params)
    }
  },
  
  warn(message, ...params) {
    if(this.level >= LoggerWarn){
      console.warn(message, ...params)
    }
  },
  
  error (message, ...params) {
    if(this.level >= LoggerError){
      console.error(message, ...params)
    }
  }
}

Logger.install = function (Vue, options) {
  window.$logger = Logger
  Vue.prototype.$logger = Logger
}

export default Logger



// WEBPACK FOOTER //
// ./src/plugins/logger.js